import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
// import LineChart from "./Charts/LineChart";
// import AreaChart from "./Charts/AreaChart";
import OrdersColumnChart from "./Charts/OrdersColumnChart";
// import POColumnChart from "./Charts/POColumnChart";
// import BarChart from "./Charts/BarChart";
import PieChart from "./Charts/PieChart";
import DonutChart from "./Charts/DonutChart";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
// import ItemService from "../../services/supplier_appCommonService";
import customerItemService from "../../services/customer_appCommonService";
import LoaderSmall from "../../Components/LoaderSmall";
import ItemService3 from "../../services/ap_auto_appCommonService";

import {
  // formatNumberShort,
  getCurrentDate,
} from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
// import SupplierConstants from "../../common/SupplierConstants";
import CustomerConstants from "../../common/CustomerConstants";
import CategoryCard from "../../Components/Cards/CategoryCard";
import PieChartCard from "./Charts/PieChartCard";
import HorizontalBarChart from "../../Components/HorizontalBarChart/HorizontalBarChart";
import CollapseCard from "../../Components/Collapsecard/Collapsecard";

const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const navigateToMainPage = (page) => {
    if (page === "totalOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V1_ORDER_BOOKING_LIST);
    } else if (page === "orderCompletedCount") {
      navigate(CustomerConstants.CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST);
    } else if (page === "confirmedDispatchCount") {
      navigate(CustomerConstants.CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST);
    } else if (page === "totalUserCount") {
      navigate(CustomerConstants.CUSTOMER_V1_CUSTOMER_MASTER_LIST);
    }
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [filterShow, setFilterShow] = useState(false);

  // eslint-disable-next-line
  const [totalUserCount, setTotalUserCount] = useState("");
  // eslint-disable-next-line
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);
  // eslint-disable-next-line
  const [confirmedDispatchCount, setConfirmedDispatchCount] = useState("");
  // eslint-disable-next-line
  const [confirmedDispatchStatus, setConfirmedDispatchStatus] = useState(false);
  // eslint-disable-next-line
  const [orderCompletedCount, setOrderCompletedCount] = useState("");
  // eslint-disable-next-line
  const [orderPendingCount, setPendingCount] = useState("");
  // eslint-disable-next-line
  const [orderCompletedStatus, setOrderCompletedStatus] = useState(false);
  // eslint-disable-next-line
  const [totalOrderCount, setTotalOrderCount] = useState("");
  // eslint-disable-next-line
  const [totalOrderCountStatus, setTotalOrderStatus] = useState(false);

  const [supplierStatusColChart, setSupplierStatusColChart] = useState("");
  const [supplierStatusColChartStatus, setSupplierStatusColChartStatus] =
    useState(false);

  // eslint-disable-next-line
  const [totalPostDispatchCount, setTotalPostDispatchCount] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);
  // eslint-disable-next-line
  const [hideItem, setHideItem] = useState(false);

  // loadOrderCount
  const loadOrderCount = async () => {
    setTotalOrderStatus(true);
    let obj = {
      queryName: "GetTotalOrderCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalOrderCount(item.data);

        loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalOrderStatus(false);
  };

  const [moduleStats, setModuleStats] = useState({});

  const loadModuleStats = async () => {
    try {
      // setLoadingStats(true)
      const payload = {
        dashboard: "customer",
        chartFilterType: "Yearly",
        chartInput2: new Date().getFullYear(),
      };
      const res = await ItemService3.getModuleStats(payload); // use your actual service method
      if (res?.status === 200) {
        setModuleStats(res?.data);
      }
    } catch (err) {
      console.log("Failed to load module stats", err);
    } finally {
      // setLoadingStats(false);
    }
  };
  useEffect(() => {
    loadModuleStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // loadOrderCompletedCount
  const loadOrderCompletedCount = async (totalOrderCountVal) => {
    setOrderCompletedStatus(true);
    let obj = {
      queryName: "totalOrderCompletedCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setOrderCompletedCount(item.data);
        let orderComplete = item.data;
        setPendingCount(totalOrderCountVal - orderComplete);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setOrderCompletedStatus(false);
  };

  // loadConfirmedDispatchCount
  const loadConfirmedDispatchCount = async () => {
    setConfirmedDispatchStatus(true);
    let obj = {
      queryName: "totalConfirmedDispatchCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setConfirmedDispatchCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setConfirmedDispatchStatus(false);
  };

  // loadCustomerCount
  const loadCustomerCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {
      queryName: "totalCustomerCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalUserCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };

  const loadPostDispatchCount = async () => {
    setTotalPostDispatchCountStatus(true);
    let obj = {
      queryName: "totalPostDispatchCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalPostDispatchCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalPostDispatchCountStatus(false);
  };

  // Suppliers Chart
  const suppliersChart = async (filterData) => {
    setSupplierStatusColChartStatus(true);
    filterData.module = "order";
    filterData.chartType = "column";

    await customerItemService.dashboard(filterData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        item.data.module = "order";
        setSupplierStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setSupplierStatusColChartStatus(false);
  };

  // PO Chart
  // const poChart = async (filterData) => {
  //   setPOStatusColChartStatus(true);
  //   filterData.module = "po";
  //   filterData.chartType = "pie";

  //   await ItemService.dashboard(filterData).then((item) => {
  //     // console.log(">> dashboard res!", item);
  //     if (item?.status === 200) {
  //       item.data.module = "po";
  //       setPOStatusColChart(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setPOStatusColChartStatus(false);
  // };

  // On Filtered Data
  const handleFilterData = async (filter) => {
    // console.log(">> filter", filter);

    await suppliersChart(filter);
    // await poChart(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };

    loadOrderCount();
    // loadOrderCompletedCount();
    loadPostDispatchCount();
    loadConfirmedDispatchCount();
    loadCustomerCount();

    suppliersChart(defaultFilter);
    // poChart(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // console.log(">> userRole", userRole);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const categoryConfigs = [
    {
      title: "Orders",
      // queryName: "Get_PR_Count_value",
      icon: "bi bi-boxes",
      fetchFunction: () =>
        customerItemService.ChartCountCard({
          queryName: "GetTotalOrderCount",
        }),
      navigateKey: "totalOrderCount",
    },
    {
      title: "Customers",
      fetchFunction: () =>
        customerItemService.ChartCountCard({
          queryName: "totalCustomerCount",
        }),
      icon: "bi bi-people",
      navigateKey: "totalUserCount",
    },
    {
      title: "Confirmed / Dispatch",
      icon: "bi bi-truck",
      splitCount: true,
      fetchFunction: async () => {
        const confirmed = await customerItemService.ChartCountCard({
          queryName: "totalConfirmedDispatchCount",
        });

        const post = await customerItemService.ChartCountCard({
          queryName: "totalPostDispatchCount",
        });

        return {
          data: {
            value: post?.data ?? 0,
            count: confirmed?.data ?? 0,
          },
        };
      },
    },
    // {
    //   title: "Completed / Pending",
    //   icon: "bi bi-box-seam",
    //   splitCount: true,
    //   fetchFunction: async () => {
    //     const confirmed = await customerItemService.ChartCountCard({
    //       queryName: "totalOrderCompletedCount",
    //     });

    //     const post = await customerItemService.ChartCountCard({
    //       queryName: "totalPostDispatchCount",
    //     });

    //     return {
    //       data: {
    //         value: post?.data ?? 0,
    //         count: confirmed?.data ?? 0,
    //       },
    //     };
    //   },
    // },

    {
      title: "Completed / Pending",
      icon: "bi bi-box-seam",
      splitCount: true,
      fetchFunction: async () => {
        // Total Orders
        const totalOrderRes = await customerItemService.ChartCountCard({
          queryName: "GetTotalOrderCount",
        });

        // Completed Orders
        const completedRes = await customerItemService.ChartCountCard({
          queryName: "totalOrderCompletedCount",
        });

        const totalOrderCountVal = Number(totalOrderRes?.data || 0);
        const orderComplete = Number(completedRes?.data || 0);
        const pendingCount = totalOrderCountVal - orderComplete;

        return {
          data: {
            count: orderComplete, // Completed
            value: pendingCount, // Pending
          },
        };
      },
    },

    // {
    //   title: "Purchase Order",
    //   queryName: "Get_PO_Count_value",
    //   // icon: FileSpreadsheet,
    //   navigateKey: "po",
    // },
    // {
    //   title: "Invoice",
    //   queryName: "Get_INV_Count_value",
    //   icon: "bi bi-currency-dollar",
    // },
    // {
    //   title: "Supplier",
    //   // queryName: "Get_PO_Count_value",
    //   // fetchFunction: ItemService.supplierCount,
    //   icon: "bi bi-people",
    //   navigateKey: "supplier",
    // },
    // {
    //   title: "Total Users",
    //   icon: "bi bi-people",
    //   navigateKey: "users",
    //   // fetchFunction: ItemService.totalUserCount, // CUSTOM API
    // },
  ];

  const pieChartConfigs = [
    {
      label: "Pre Dispacth",
      color: "#00A3FF",
      fetchFunction: () =>
        customerItemService.generateCustomerQuery({
          queryName: "getOrderScheduleSOList",
        }),
    },
    {
      label: "Post Dispacth",
      color: "#00E5A0",
      fetchFunction: () =>
        customerItemService.generateCustomerQuery({
          queryName: "getDispatchDocList",
        }),
    },
    {
      label: "Dispacth Confirmed",
      color: "#9C27B0",
      fetchFunction: () =>
        customerItemService.generateCustomerQuery({
          queryName: "getConfirmDispatchDocList",
        }),
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <section className="section">
              <section className="section">
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Team">
                    {/* <h5 className="card-title mb-3">My Category</h5> */}
                    <div className="row g-3">
                      {categoryConfigs.map((item, index) => (
                        <div
                          className="col-12 col-md-6 col-lg-3 px-2"
                          key={index}
                        >
                          <CategoryCard
                            {...item}
                            onClick={() => navigateToMainPage(item.navigateKey)}
                          />
                        </div>
                      ))}
                    </div>
                  </CollapseCard>
                </div>
              </section>
              {filterShow && (
                <DatePickerComponent
                  getfiltereddata={handleFilterData}
                  cancelAction={() => setFilterShow(!filterShow)}
                />
              )}

              <div className="row">
                {/* Delivery */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Delivery">
                    <div className="col-lg-6 col-md-6">
                      <div className="card h-100 dashboard-card-gap">
                        <div className="card-body p-2">
                          <HorizontalBarChart
                            title=""
                            data={moduleStats?.cust_delivery?.chartData}
                          />
                        </div>
                      </div>
                    </div>
                  </CollapseCard>
                </div>
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <CollapseCard title="Orders">
                    {/* <h5 className="card-title">Orders</h5> */}

                    {/* <div id="columnChart"></div> */}
                    <LoaderSmall isLoading={supplierStatusColChartStatus} />
                    <h6>
                      {!supplierStatusColChartStatus ? (
                        <OrdersColumnChart
                          key="order"
                          chartdata={supplierStatusColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </CollapseCard>
                </div>
                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <CollapseCard title="Sales Team">
                    {/* <h5 className="card-title">Sales Team</h5> */}
                    <div id="pieChart"></div>
                    <PieChart />
                  </CollapseCard>
                </div>
                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <CollapseCard title="Orders">
                    {/* <h5 className="card-title">Orders</h5> */}
                    <div id="pieChart"></div>
                    <PieChartCard
                      title=""
                      chartConfigs={pieChartConfigs}
                      chartType="pie"
                      showToolbar={true}
                    />
                  </CollapseCard>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <CollapseCard title="Marketing Team">
                    {/* <h5 className="card-title">Marketing Team</h5> */}
                    <div id="donutChart"></div>
                    <DonutChart />
                  </CollapseCard>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
